export const BASE_API_URL = document.getElementById('shopsListWrap').dataset.apiUrl
export const BASE_API_URL_SHOPS = document.getElementById('shopsListWrap').dataset.apiUrlShops
export const BASE_API_URL_SERVICES = document.getElementById('shopsListWrap').dataset.apiUrlServices
export const BASE_API_URL_FOODS = document.getElementById('shopsListWrap').dataset.apiUrlFoods

export const T_LANG = document.getElementById('shopsListWrap').dataset.tLang
export const T_CATEGORIES = document.getElementById('shopsListWrap').dataset.tCategories
export const T_SHOPS = document.getElementById('shopsListWrap').dataset.tShops
export const T_SERVICES = document.getElementById('shopsListWrap').dataset.tServices
export const T_FOODS = document.getElementById('shopsListWrap').dataset.tFoods
export const T_LIST_TITLE = document.getElementById('shopsListWrap').dataset.tListTitle
export const T_BACK_BTN = document.getElementById('shopsListWrap').dataset.tBackBtn
export const BACK_BTN_LINK = document.getElementById('shopsListWrap').dataset.backBtnLink
export const T_ORDER_BY = document.getElementById('shopsListWrap').dataset.tOrderBy
export const T_SEARCH_PLACEHOLDER = document.getElementById('shopsListWrap').dataset.tSearchPlaceholder
export const T_WORKING_HOURS = document.getElementById('shopsListWrap').dataset.tWorkingHours
export const T_SHOW_CATEGORIES = document.getElementById('shopsListWrap').dataset.tShowCategories
export const T_NO_DATA = document.getElementById('shopsListWrap').dataset.tNoData

export const ORDER_BY_VALUES = JSON.parse(document.getElementById('shopsListWrap').dataset.orderValues)
export const SHOP_COLOR = document.getElementById('shopsListWrap').dataset.shopColor



// WEBPACK FOOTER //
// ./src/config/AppConfig.js